<template>
    <section class="card-section">
        <div class="section-title">
            <h2>Cabeçalho da inspeção</h2>
            <span>Identificação do estabelecimento, atividade e responsáveis</span>
        </div>

        <div class="form-grid cols-4">
            <div class="form-item">
                <label>Nº do laudo</label>
                <input v-model="localModel.numeroLaudo" type="text">
            </div>

            <div class="form-item col-2">
                <label>Razão social</label>
                <input v-model="localModel.razaoSocial" type="text">
            </div>

            <div class="form-item">
                <label>Nome fantasia</label>
                <input v-model="localModel.nomeFantasia" type="text">
            </div>

            <div class="form-item">
                <label>Registro no SIM</label>
                <input v-model="localModel.numeroRegistroSim" type="text">
            </div>

            <div class="form-item">
                <label>Inscrição estadual</label>
                <input v-model="localModel.inscricaoEstadual" type="text">
            </div>

            <div class="form-item">
                <label>CNPJ / CPF</label>
                <input v-model="localModel.cnpjCpf" type="text">
            </div>

            <div class="form-item col-2">
                <label>Endereço</label>
                <input v-model="localModel.endereco" type="text">
            </div>

            <div class="form-item">
                <label>Bairro</label>
                <input v-model="localModel.bairro" type="text">
            </div>

            <div class="form-item">
                <label>Município</label>
                <input v-model="localModel.municipio" type="text">
            </div>

            <div class="form-item">
                <label>CEP</label>
                <input v-model="localModel.cep" type="text">
            </div>

            <div class="form-item">
                <label>UF</label>
                <input v-model="localModel.uf" type="text" maxlength="2">
            </div>

            <div class="form-item">
                <label>Telefone</label>
                <input v-model="localModel.telefone" type="text">
            </div>

            <div class="form-item">
                <label>E-mail</label>
                <input v-model="localModel.email" type="text">
            </div>

            <div class="form-item">
                <label>Data da inspeção</label>
                <input v-model="localModel.dataInspecao" type="date">
            </div>

            <div class="form-item col-2">
                <label>Classificação do estabelecimento</label>
                <input v-model="localModel.classificacaoEstabelecimento" type="text">
            </div>

            <div class="form-item">
                <label>Possui responsável técnico?</label>
                <select v-model="localModel.possuiResponsavelTecnico">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item" v-if="localModel.possuiResponsavelTecnico === 'N'">
                <label>Se não, qual?</label>
                <input v-model="localModel.responsavelTecnicoQual" type="text">
            </div>

            <div class="form-item col-2">
                <label>Nome do responsável técnico</label>
                <input v-model="localModel.nomeResponsavelTecnico" type="text">
            </div>

            <div class="form-item">
                <label>Formação acadêmica</label>
                <input v-model="localModel.formacaoAcademica" type="text">
            </div>

            <div class="form-item">
                <label>Nº de pessoas que trabalham na atividade</label>
                <input v-model.number="localModel.numeroPessoasAtividade" type="number" min="0">
            </div>

            <div class="form-item">
                <label>Nº de turnos</label>
                <input v-model.number="localModel.numeroTurnos" type="number" min="0">
            </div>
        </div>

        <div class="section-subtitle">Responsável por acompanhar a inspeção</div>

        <div class="form-grid cols-3">
            <div class="form-item">
                <label>Nome completo</label>
                <input v-model="localModel.nomeAcompanhante" type="text">
            </div>

            <div class="form-item">
                <label>CPF</label>
                <input v-model="localModel.cpfAcompanhante" type="text">
            </div>

            <div class="form-item">
                <label>Função</label>
                <input v-model="localModel.funcaoAcompanhante" type="text">
            </div>
        </div>

        <div class="section-subtitle">Motivo da inspeção</div>

        <div class="form-grid cols-3">
            <div class="form-item col-2">
                <label>Motivo principal</label>
                <select v-model="localModel.motivoInspecao">
                    <option value="LAUDO DE INSPEÇÃO SANITÁRIA ANUAL">Laudo de inspeção sanitária anual</option>
                    <option value="OUTROS">Outros</option>
                </select>
            </div>

            <div class="form-item" v-if="localModel.motivoInspecao === 'OUTROS'">
                <label>Descrever outros</label>
                <input v-model="localModel.motivoOutros" type="text">
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
})

const emit = defineEmits(['update:modelValue'])

const localModel = computed({
    get: () => props.modelValue,
    set: value => emit('update:modelValue', value),
})
</script>

<style scoped>
.card-section {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 10px;
    padding: 16px;
}

.section-title h2 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
}

.section-title span {
    display: block;
    margin-top: 4px;
    color: #6b7280;
    font-size: 13px;
}

.section-subtitle {
    margin: 18px 0 10px;
    font-weight: 600;
    color: #334155;
}

.form-grid {
    display: grid;
    gap: 12px;
}

.cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.col-2 {
    grid-column: span 2;
}

.form-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-item label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
}

.form-item input,
.form-item select,
.form-item textarea {
    height: 38px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 0 10px;
    outline: none;
}

@media (max-width: 1100px) {
    .cols-3,
    .cols-4 {
        grid-template-columns: 1fr;
    }

    .col-2 {
        grid-column: span 1;
    }
}
</style>